import React from "react";
import { TimePicker } from "..";
import { FormDatePickerBase, FormDatePickerProps } from "./DatePickerBase";

export const DateTimePicker = (props: Omit<FormDatePickerProps, "mode">) => {
  const { value, onChange, minDate, maxDate, ...rest } = props;

  const onTimeChange = (timeMoment: moment.Moment) => {
    const oldDate = value.clone();

    oldDate.set({
      hour: timeMoment.get("hour"),
      minute: timeMoment.get("minute"),
      second: timeMoment.get("second")
    });

    onChange(oldDate, false);
  };

  return <div className="flex gap-small">
    <FormDatePickerBase
      mode="single"
      value={value}
      onChange={onChange}
      minDate={minDate.clone().startOf("day")}
      maxDate={maxDate.clone().startOf("day")}
      {...rest}
    />
    <TimePicker
      value={value}
      onChange={onTimeChange}
      error={props.error}
    />
  </div>
}